<ng-template #eSignatureButtonTemplate let-remainingDocument >
    @if (hasEsignaturePlus() && remainingDocument?.docusignEnvelope){
    <button data-cy="eSignature-doc-requirement-button"
        [cdkOverlayOrigin]
        #eSignatureButton="cdkOverlayOrigin"
        mat-icon-button
        matTooltip="eSignature"
        matTooltipPosition="above" 
        (click)="handleEsignatureClick($event, remainingDocument)"
        >
        <mat-icon class="material-symbols-outlined">ink_pen</mat-icon>
    </button>
    <ng-template
        [cdkConnectedOverlay]
        [cdkConnectedOverlayOrigin]="eSignatureButton"
        [cdkConnectedOverlayOpen]="showDocusignTimestamps === remainingDocument?.documentCategory?.name"
        [cdkConnectedOverlayPositions]="[
            { originX: 'center', originY: 'bottom', overlayX: 'start', overlayY: 'top' }
        ]"
        [cdkConnectedOverlayOffsetX]="remainingDocument?.source === 'documentRequest' ? 62 : 20"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
        (overlayOutsideClick)="handleOverlayOutsideClick()"
        (detach)="handleOverlayClose()"
        >
        <app-process-timestamps-tooltip
            tooltipTitle="eSignature Status"
            [timestamps]="remainingDocument?.docusignEnvelope?.events">
        </app-process-timestamps-tooltip>
    </ng-template>
    }
</ng-template>


<ng-template #deleteButton let-remainingDocument>
    @if (remainingDocument?.source === 'documentRequest') {
    <button data-cy="delete-doc-requirement-button" mat-icon-button matTooltip="Delete" matTooltipPosition="above"
        (click)="handleRequirementDelete($event, remainingDocument)">
        <mat-icon>delete_outlined</mat-icon>
    </button>
    }
</ng-template>

<ng-template #itemText let-remainingDocument>
    <div class="item-text">
        <span class="document-title">
            {{ remainingDocument?.documentCategory?.name }}
            @if (remainingDocument?.timePeriod) {
            - {{ remainingDocument?.timePeriod }}
            }
        </span>
        @if (hasEsignaturePlus() && remainingDocument?.docusignEnvelope?.contacts?.length > 0) {
        <span class="signer-name">
            {{ remainingDocument?.docusignEnvelope?.contacts[0].first | titlecase }}
            {{ remainingDocument?.docusignEnvelope?.contacts[0].last | titlecase }}
        </span>
        }
    </div>
</ng-template>

<section data-cy="document-requirements-component" class="document-requirements" 
    [class.no-requirements]="!hasRequirements()">

    <!-- Header button -->
    <mat-expansion-panel expanded="true" class="mat-elevation-z0 !rounded-lg" [disabled]="!hasRequirements()">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="requirements-title">
                    <div class="flex gap-1">
                        <div>Requirements</div>
                        @if (canAddDocumentRequirements()) {
                        <button class="add-document-requirements-button"
                                data-cy="add-document-requirements-button"
                                (click)="openDocumentRequirementDialog($event)">
                            <mat-icon>add</mat-icon>
                        </button>
                        }
                    </div>
                    <!-- Accepted fraction -->
                    <div class="accepted-fraction">{{ acceptedFraction() }}</div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- List of Document requirements -->
        @if (hasRequirements()) {
        <ul class="max-w-[352px]">
            <!-- Not yet uploaded -->
            @for (remainingDocument of notUploaded(); track $index) {
            <li data-cy="document-requirement" class="document-requirement"
                (mouseenter)="handleDocRequirementMouseEnter($event, remainingDocument)"
                (mouseleave)="handleDocRequirementMouseLeave($event, remainingDocument)"
                >
                <div class="organizing-container">
                    <div class="left-elements"
                        [class.hover-effect]="remainingDocument?.source === 'documentRequest' || (hasEsignaturePlus() && remainingDocument?.docusignEnvelope)">
                        <mat-icon class="icon">empty</mat-icon>
                        <ng-container
                            *ngTemplateOutlet="itemText; context: { $implicit: remainingDocument }"></ng-container>
                    </div>
                    <div class="right-elements">
                        <ng-container
                            *ngTemplateOutlet="eSignatureButtonTemplate; context: { $implicit: remainingDocument }"></ng-container>
                        <ng-container
                            *ngTemplateOutlet="deleteButton; context: { $implicit: remainingDocument }"></ng-container>
                    </div>
                </div>
            </li>
            }

            <!-- Uploaded but not accepted -->
            @for (remainingDocument of uploadedButNotAccepted(); track $index) {
            <li data-cy="document-requirement" class="document-requirement"
                (mouseenter)="handleDocRequirementMouseEnter($event, remainingDocument)"
                (mouseleave)="handleDocRequirementMouseLeave($event, remainingDocument)">
                <div class="organizing-container">
                    <div class="left-elements">
                        <div class="icon">
                            <!-- Homemade indicator -->
                            <div class="not-accepted-icon" matTooltip="Under review" matTooltipPosition="above"></div>
                        </div>
                        <ng-container
                            *ngTemplateOutlet="itemText; context: { $implicit: remainingDocument }"></ng-container>
                    </div>
                    <div class="right-elements"
                        [class.hover-effect]="remainingDocument?.source === 'documentRequest' || (hasEsignaturePlus() && remainingDocument?.docusignEnvelope)">
                        <ng-container
                            *ngTemplateOutlet="eSignatureButtonTemplate; context: { $implicit: remainingDocument }"></ng-container>
                        <ng-container
                            *ngTemplateOutlet="deleteButton; context: { $implicit: remainingDocument }"></ng-container>
                    </div>
                </div>
            </li>
            }

            <!-- Accepted -->
            @for (acceptedDocument of documentRequirements().satisfied; track $index) {
            <li data-cy="document-requirement" class="document-requirement">
                <div class="organizing-container">
                    <div class="left-elements">
                        <mat-icon class="icon accepted" matTooltip="Accepted">check_small</mat-icon>
                        <ng-container
                            *ngTemplateOutlet="itemText; context: { $implicit: acceptedDocument }"></ng-container>
                    </div>
                </div>
            </li>
            }
        </ul>
        }
    </mat-expansion-panel>
</section>
